import { apiErrorMessage } from "../services/apiError";

export function mailErrorMessage(error) {
    const fallback = error?.response?.status === 401
        ? "Session expirée. Veuillez vous reconnecter."
        : "Erreur lors de l'envoi du mail.";
    return apiErrorMessage(error, fallback);
}
